// Expose jQuery globally so legacy plugins (Bootstrap, Select2) and the step
// modules that rely on the bare `$`/`jQuery` globals keep working under esbuild.
// This file MUST be imported first in the entrypoint.
import jquery from "jquery";

window.jQuery = jquery;
window.$ = jquery;
globalThis.jQuery = jquery;
globalThis.$ = jquery;

// Select2 v4 ships as a factory that must be registered against our jQuery
// instance to attach `$.fn.select2`. The actual initialization stays in
// application.js (`$("select.custom-select").select2()`).
import select2 from "select2";
select2(window.$);
